import React, { Dispatch, FC, SetStateAction } from 'react'
import useFlashMessage from 'hooks/useFlashMessage'
import { updateArtworkInMyCollection } from './helpers'
import styles from './Layout.module.scss'
import Checkbox from 'components/SA/FormElements/Checkbox'

type CollectionListItemProps = {
  title: string
  artworkId: number
  artworksCount: number
  userCollectionId: number
  artworkList: ReadonlyArray<number>
  setIsUpdatingCollectionList: Dispatch<SetStateAction<boolean>>
  onRefetchCollectionsData?: () => Promise<void>
}

const CollectionListItem: FC<CollectionListItemProps> = ({
  title,
  artworkId,
  artworksCount,
  userCollectionId,
  artworkList,
  setIsUpdatingCollectionList,
  onRefetchCollectionsData,
}) => {
  const { showErrorMessage } = useFlashMessage()

  const isSelected = artworkList.includes(userCollectionId)

  const handleAddOrRemoveFromCollection = async () => {
    setIsUpdatingCollectionList(true)
    const response = await updateArtworkInMyCollection({
      artworkId,
      userCollectionId,
      action: isSelected ? 'REMOVE' : 'ADD',
    })

    if (response.type === 'error') {
      showErrorMessage(response)
    }
    await onRefetchCollectionsData?.()
    setIsUpdatingCollectionList(false)
  }

  return (
    <div className={styles.collectionsListItemBox} onClick={handleAddOrRemoveFromCollection}>
      <h6>
        {title} ({artworksCount || 0})
      </h6>
      <Checkbox name={title} checked={isSelected} size='large' />
    </div>
  )
}

export default CollectionListItem
